@if (hasAnyPassword()) {
    <div class="border-border mb-2 rounded-md border bg-card p-3 text-xs">
        <div class="mb-2 font-medium text-card-foreground">{{ 'Password Requirements:' | translate }}</div>
        <div class="space-y-1">
            @for (condition of conditions(); track condition.key) {
                <div class="flex items-center gap-2">
                    @if (condition.met) {
                        <svg class="h-4 w-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                    } @else {
                        <svg class="h-4 w-4 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    }
                    <span [class]="condition.met ? 'text-green-600' : 'text-red-500'">
                        {{ condition.label | translate }}
                    </span>
                </div>
            }
        </div>
        @if (allConditionsMet()) {
            <div class="mt-2 flex items-center gap-2 text-green-600">
                <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span class="font-medium">{{ 'All requirements met!' | translate }}</span>
            </div>
        }
    </div>
}
